import { baseThemeValues } from 'constants/common';

const tabBase = {
  activeLine: 'palette.primary.20',
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 500,
};

export const editorSidebarTheme = {
  accordion: {
    active: {
      borderColor: 'palette.primary.20',
      text: 'palette.neutral.99',
    },
    base: {
      bg: 'palette.transparent',
      borderColor: 'palette.transparent',
      borderWidth: '2px',
      text: 'palette.neutral.90',
    },
    hover: {
      bg: 'palette.surface.4',
    },
    opened: {
      bg: 'palette.surface.5',
      text: 'palette.neutral.99',
    },
  },
  behaviors: {
    borderColor: 'palette.tertiary.20',
    borderWidth: '1px',
    label: {
      fontFamily: baseThemeValues.inherit,
      fontSize: '14px',
      fontWeight: '600',
      text: 'palette.neutral.90',
    },
  },
  bg: 'palette.surface.3',
  closeBarButton: 'palette.neutral.70',
  components: {
    groupTitle: {
      fontFamily: baseThemeValues.inherit,
      fontSize: '12px',
      fontWeight: 600,
      text: 'palette.neutral.70',
    },
    innerComponentsList: {
      groupLine: 'palette.surface.5',
    },
    property: {
      active: {
        borderColor: 'palette.primary.20',
        text: 'palette.tertiary.95',
      },
      base: {
        borderColor: 'palette.transparent',
        borderWidth: '2px',
        text: 'palette.tertiary.90',
      },
    },
  },
  section: {
    borderColor: 'palette.tertiary.20',
    borderWidth: '1px',
    subtitle: 'palette.neutral.80',
    title: 'palette.neutral.90',
  },
  tabs: {
    bg: 'palette.surface.3',
    borderColor: 'palette.surface.5',
    borderWidth: '1px',
    tab: {
      base: {
        ...tabBase,
        bg: 'palette.transparent',
        text: 'palette.tertiary.60',
      },
      hover: {
        ...tabBase,
        bg: 'palette.surface.4',
        text: 'palette.tertiary.80',
      },
      pressed: {
        ...tabBase,
        bg: 'palette.surface.5',
        text: 'palette.tertiary.60',
      },
    },
  },
  typography: {
    item: {
      container: {
        active: {
          borderColor: 'palette.primary.20',
        },
        base: {
          borderColor: 'palette.transparent',
          borderWidth: '2px',
        },
      },
      divider: 'palette.tertiary.20',
      preview: {
        fontSize: '14px',
        text: 'palette.neutral.90',
      },
      select: {
        bg: 'palette.surface.3',
        borderColor: 'palette.surface.4',
        scrollThumb: 'palette.surface.5',
      },
      text: 'palette.neutral.90',
    },
    preview: {
      fontSize: '50px',
      text: 'palette.tertiary.95',
    },
  },
};
